<template>
  <component :is="view">
    <template v-slot:header>
      <slot name="header" />
    </template>
    <slot></slot>
  </component>
</template>

<script>
import NormalFrame from './NormalFrame'
import TrueidFrame from './TrueidFrame'
export default {
  computed: {
    view() {
      if (['TRUEIDTEST', 'TRUEID'].includes(this.$store.state.apiKey)) {
        return 'TrueidFrame'
      } else {
        return 'NormalFrame'
      }
    }
  },
  components: {
    NormalFrame,
    TrueidFrame
  }
}
</script>

<style lang="scss" scoped></style>
